// extracted by mini-css-extract-plugin
export var centerText = "_fh-8";
export var container = "_fh-0";
export var doughnutContainer = "_fh-7";
export var legend = "_fh-a";
export var legendItemColorDisplay = "_fh-b";
export var legendItemLabel = "_fh-d";
export var legendItemValue = "_fh-c";
export var lg = "_fh-5";
export var maxWidth = "_fh-9";
export var md = "_fh-4";
export var responsive = "_fh-6";
export var sm = "_fh-3";
export var xs = "_fh-2";
export var xxs = "_fh-1";